
document.addEventListener("DOMContentLoaded", function() {
    const slides = document.querySelectorAll('.blog-slide');
    let maxHeight = 0;

    slides.forEach(slide => {
    slide.style.height = 'auto';
    maxHeight = Math.max(maxHeight, slide.offsetHeight);
    });

    slides.forEach(slide => {
    slide.style.height = maxHeight + 'px';
    });
});